import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Initial Results of my Patreon Experiment",
  "description": "",
  "published": "2017-06-19T00:00:00.000Z",
  "redirect_from": ["/blog/initial-results-patreon-experiment/swizec/7666"],
  "categories": "Business, Learning, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Just over a week ago, I sent this email to 7,517 people.`}</p>
    <p><em parentName="p">{`Do you enjoy learning from me?`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/06/email-screenshot.jpg",
        "alt": null
      }}></img></p>
    <p>{`2,461 people opened that email. 60 unsubscribed, and 7 wrote a reply. 3 of those were vacation autoresponders.`}</p>
    <p>{`Clicking `}<inlineCode parentName="p">{`Yes`}</inlineCode>{` opened a `}<a parentName="p" {...{
        "href": "https://www.patreon.com/swizec"
      }}>{`Patreon page`}</a>{` with monthly patronages ranging from $3 upwards. 226 people clicked that.`}</p>
    <p>{`But only 6 people converted on Patreon itself, and one of them was my girlfriend 🤔`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/06/barchart-screenshot.jpg",
        "alt": null
      }}></img></p>
    <p>{`That's a conversion rate of 2% on Patreon itself and a rate of 0.6% overall. It sounds terrible, but it’s similar to numbers I've seen elsewhere. Honestly, I thought it was worse.`}</p>
    <p>{`Convincing people to swipe their card is hard. Especially if it's for a monthly subscription.`}</p>
    <p>{`Of those 7,517 people, only 51 clicked `}<inlineCode parentName="p">{`No`}</inlineCode>{`. They were taken to a Google Form with a single input box. `}<em parentName="p">{`Why not?`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/06/google-form-screenshot.jpg",
        "alt": null
      }}></img></p>
    <p>{`Of those 51, 10 people wrote great feedback (for the most part).`}</p>
    <p>{`One meanie said `}<em parentName="p">{`"No”`}</em>{`, and another meanie said `}<em parentName="p">{`"stop writing"`}</em>{`. Those were… uncalled for.`}</p>
    <p>{`But I also got great feedback like this:`}</p>
    <blockquote>
      <p parentName="blockquote">{`I like your business insights and your honesty, but I'm not a React guy (which you talk about) (I'm the bright side - called VueJS :). Also, I wish you would cover more ground in your emails, more links thoughts and resources. Keep up your good work though - I'm sure you'll find the perfect product-market-fit!`}</p>
    </blockquote>
    <p>{`And stuff like this:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Sometimes entertaining/informative, way too random and inconsistent to pay for.`}</p>
    </blockquote>
    <p>{`Or this:`}</p>
    <blockquote>
      <p parentName="blockquote">{`I like the tone of your emails, they are always fun to read, and I almost always will open them. But a lot of the content I cannot use in my daily work. I guess I feel like the scope is very large. I tend to like content that helps me solve an isolated and specific problem.`}</p>
    </blockquote>
    <p>{`Overall, people seem to enjoy my emails, but not enough to pay for. Which makes sense. Why would you pay for something that doesn't feel like a coherent product?`}</p>
    <p>{`My weekly emails just aren't a coherent product (yet?). Maybe one day they will be, maybe they won't. It's hard to decide which direction to take it all because I think a large part of what makes a great engineer is his or her breadth of knowledge. And it's that breadth that I want to offer.`}</p>
    <p>{`But breadth is difficult to productize. That's why my flagship product is a book that talks about putting just two libraries together :D`}</p>
    <p>{`Overall, I can't decide if the Patreon experiment is a great success or a total bust.`}</p>
    <p>{`$37 monthly recurring revenue is pretty cool, but it’s nothing to write home about. Can it grow from here? Could I get to a point where I don't have to sell products anymore and could rely just on monthly subscriptions in a few months to a year?`}</p>
    <p>{`¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`Would be nice, tho. Launches are stressful and putting books and courses together is always harder than it looks.`}</p>
    <p>{`Most of all, 226 people who said `}<em parentName="p">{`"Yes, I enjoy this as much as caffeine"`}</em>{` versus 51 who said `}<em parentName="p">{`"Nah"`}</em>{`, `}<strong parentName="p">{`that's`}</strong>{` a win. I'm doing something right; now I just have to figure out what it is. 😅`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      